import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, get, errMsg } from "@/lib/api";
import { confirmAction } from "@/components/app/Confirm";

export const plural = (n, w) => `${n} ${w}${n === 1 ? "" : "s"}`;

/** Confirm, call the endpoint, toast. Returns true when deleted. */
export async function deleteItem({ title, entity, body, typeToConfirm, url, method = "delete", data, success, onDone, confirmLabel = "Delete" }) {
  if (!(await confirmAction({ title, entity, body, typeToConfirm, confirmLabel }))) return false;
  try {
    if (method === "post") await api.post(url, data); else await api.delete(url);
    toast.success(success);
    onDone?.();
    return true;
  } catch (e) {
    toast.error(errMsg(e));
    return false;
  }
}

const also = (parts) => {
  const p = parts.filter(([n]) => n > 0).map(([n, w]) => plural(n, w));
  return p.length ? `This also removes ${p.join(", ")}.` : "Nothing else is linked to it.";
};

export async function deleteJob(job, onDone) {
  let imp = {};
  try { imp = await get(`/jobs/${job.id}/delete-impact`); } catch (e) { toast.error(errMsg(e)); return false; }
  const kept = imp.candidates_kept ? ` ${plural(imp.candidates_kept, "candidate")} who also applied to other jobs will be kept.` : "";
  return deleteItem({
    title: "Delete this job?", entity: job.title || "Untitled job", typeToConfirm: (job.title || "").trim() || "DELETE",
    body: `${also([[imp.applications, "application"], [imp.candidates_deleted, "candidate"], [imp.invites, "assessment invite"], [imp.interviews, "interview"]])}${kept} Resumes, scores, notes and files go too. This can't be undone.`,
    url: `/jobs/${job.id}`, success: `Deleted "${job.title || "Untitled job"}"`, onDone,
  });
}

export async function deleteCandidate(c, onDone) {
  let imp = {};
  try { imp = await get(`/candidates/${c.id}/delete-impact`); } catch (e) { toast.error(errMsg(e)); return false; }
  return deleteItem({
    title: "Delete this candidate entirely?", entity: c.name || c.display_name,
    body: `${also([[imp.applications, "application"], [imp.invites, "assessment invite"], [imp.interviews, "interview"]])} Their resume and files are deleted from storage. This can't be undone.`,
    url: `/candidates/${c.id}`, success: "Candidate deleted", onDone,
  });
}

export const deleteInterview = (r, onDone) => deleteItem({
  title: "Delete this interview?", entity: `${r.name || r.candidate_name || "Candidate"}${r.job_title ? ` · ${r.job_title}` : ""}`, typeToConfirm: "DELETE",
  body: "This permanently deletes the recordings, transcripts, AI scores, rubric results, flags and reports for this interview. This can't be undone.",
  url: `/interviews/${r.id}`, success: "Interview deleted", onDone,
});

export const TrashButton = ({ label, onClick, testId, disabled }) => (
  <Button variant="ghost" size="sm" aria-label={label} title={label} disabled={disabled} data-testid={testId}
    onClick={(e) => { e.stopPropagation(); onClick(); }} onKeyDown={(e) => e.stopPropagation()} className="text-ink-muted hover:text-risk">
    <Trash2 size={15} />
  </Button>
);
